var map = {
	"./house-icon.png": 7459,
	"./left-arrow-icon.png": 8087,
	"./logout-icon.png": 3736,
	"./right-arrow-icon.png": 9326,
	"./tools-icon.png": 8555,
	"./warning-icon.png": 5072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6088;